import React from 'react';
import { SHADCN, R } from '../theme';

// ── <IconButton> — Shadcn dark ──────────────────────────────────────────────
// Tailles : sm 32 / md 36 / lg 40. Variants : ghost / filled.

const SIZES = { sm: 32, md: 36, lg: 40 };

export default function IconButton({
  children,
  variant = 'ghost',
  size = 'md',
  disabled = false,
  type = 'button',
  style,
  ...rest
}) {
  const dim = SIZES[size] || SIZES.md;

  const base = {
    position: 'relative',
    width: dim,
    height: dim,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    borderRadius: R.md,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: `background ${SHADCN.durBase} ${SHADCN.easeOut}, color ${SHADCN.durBase} ${SHADCN.easeOut}, border-color ${SHADCN.durBase} ${SHADCN.easeOut}, transform 90ms ${SHADCN.easeOut}`,
    opacity: disabled ? 0.4 : 1,
    color: SHADCN.mutedFg,
    flexShrink: 0,
  };

  const variants = {
    ghost:  { background: 'transparent', border: '1px solid transparent' },
    filled: { background: SHADCN.sidebarAccent, border: `1px solid ${SHADCN.border}` },
  };

  return (
    <button
      type={type}
      disabled={disabled}
      {...rest}
      data-sonore-btn=""
      style={{ ...base, ...variants[variant], ...style }}
      onPointerEnter={(e) => {
        if (disabled || e.pointerType === 'touch') return;
        e.currentTarget.style.color = SHADCN.fg;
        if (variant === 'ghost') e.currentTarget.style.background = SHADCN.sidebarAccent;
        else e.currentTarget.style.background = SHADCN.muted;
      }}
      onPointerLeave={(e) => {
        e.currentTarget.style.color = SHADCN.mutedFg;
        e.currentTarget.style.background = variant === 'ghost' ? 'transparent' : SHADCN.sidebarAccent;
      }}
    >
      {children}
    </button>
  );
}
